import Repo from './Repo.js'

export default class SectorRepository extends Repo {
  constructor () {
    super('sectors')
  }

  all (q) {
    return super.all(q)
  }

  store (data) {
    return super.store(data)
  }

  update (id, data) {
    return super.update(id, data)
  }

  get (id, include) {
    return super.get(id, {include: include})
  }

  delete (id) {
    return super.delete(id)
  }

  paginate (q) {
      return super.paginate(q)
  }

  paginatedUsers(id, data){
      return this.http.get(this.resource + '/' + id + '/users/paginated', data).then((response) => {
          return Promise.resolve(response)
      }).catch((response) => {
          return Promise.reject(response)
      })
  }
}
